import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';

import { Image, UIHeading1, UIText1 } from '@cian/ui-kit';
import HeroImg from '../../static/hero/mobile_hero.svg';

export enum EBackgrounds {
  nn = 'nn',
  agent = 'agent',
  default = 'default',
}

export interface IHeroBannerProps {
  backgroundFor: EBackgrounds;
}

export const HeroBanner: React.FC<IHeroBannerProps> = ({ backgroundFor }) => {
  return (
    <div data-testid="HeroBanner" className={cn(styles['container'], styles[`background-for--${backgroundFor}`])}>
      <div className={styles['top-content']}>
        <div className={styles['title']}>
          <UIHeading1>Оцените квартиру бесплатно</UIHeading1>
        </div>
        <Image width={120} height={120} src={HeroImg} />
      </div>

      <UIText1>Онлайн-проверка рыночной стоимости и арендной ставки</UIText1>
    </div>
  );
};

HeroBanner.displayName = 'HeroBanner';
